// extracted by mini-css-extract-plugin
export default {"caption":"index_caption_NV-hQ clearfix","sub_title":"index_sub_title_65mos"};